import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { ReservationCreateComponent } from './reservation-create/reservation-create.component';
import { ReservationEditComponent } from './reservation-edit/reservation-edit.component';
import { ReservationComponent } from './reservation.component';
import { ReservationCategoriesComponent } from './reservation-categories/reservation-categories.component';

export const reservationsRoutes: Routes = [
  {
    path: 'reservation',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: 'create',
        component: ReservationCreateComponent,
      },
      {
        path: ':reservationId/edit',
        component: ReservationEditComponent,
      },
      {
        path: 'reservation-categories/:reservationCategory',
        component: ReservationCategoriesComponent,
      },
      {
        path: '',
        component: ReservationComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/reservation/reservation.routes.ts